import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var GetOutstandingsCtrl = function (fn, er, state, token, ids) {

	var config = {
		headers: {
		'Authorization': 'Bearer ' + token,
		'Content-Type': 'application/json',
		'MT_SESSION_ID': ids
		},

	};
	var data = {
		date: "",
		orderBy: "",
		page: 1
	};

	axios
		.post(ApiConfig.url.GET_OUTSTANDING, data, config)
		.then(function (result) {
			fn(result.data, result.status)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { GetOutstandingsCtrl };